



























































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import ContentComposer from '@/views/browse-and-go/components/ContentComposer.vue'
import { cloneData } from '@/services/browse-and-go/labels'
import { bngState, deleteProgram, saveProgram } from '@/services/browse-and-go/store'
import { BenefitProgram, MerchantRate } from '@/services/browse-and-go/types'

function blankProgram(): BenefitProgram {
  return {
    id: '',
    name: '',
    logo: '',
    isDefault: false,
    merchantIds: [],
    rates: {},
    builtin: false
  }
}

@Component({
  name: 'BrowseAndGoBenefitEdit',
  components: { PageHeader, ContentComposer }
})
export default class extends Vue {
  private draft: BenefitProgram = blankProgram()
  private ready = false
  private wasDefault = false

  get isCreate() {
    return this.$route.name === 'BrowseAndGoBenefitCreate'
  }

  get merchants() {
    return bngState.merchants
  }

  @Watch('$route.fullPath', { immediate: true })
  private load() {
    if (this.isCreate) {
      this.draft = blankProgram()
      this.wasDefault = false
      this.ready = true
      return
    }
    const program = bngState.programs.find(item => item.id === String(this.$route.params.id || ''))
    if (!program) {
      this.$message.error('Modèle de Programme Avantages introuvable')
      this.$router.replace({ name: 'BrowseAndGoBenefits' })
      return
    }
    this.draft = cloneData(program)
    this.wasDefault = program.isDefault
    this.ready = true
  }

  private onAddIds(ids: string[]) {
    ids.forEach(id => {
      if (!this.draft.merchantIds.includes(id)) this.draft.merchantIds.push(id)
      if (!this.draft.rates[id]) Vue.set(this.draft.rates, id, { commission: 8, discount: 5 })
    })
  }

  private onRemove(id: string) {
    this.draft.merchantIds = this.draft.merchantIds.filter(item => item !== id)
  }

  private onClear() {
    this.draft.merchantIds = []
  }

  private onRate(payload: { id: string; key: 'commission' | 'discount'; value: number }) {
    const current: MerchantRate = this.draft.rates[payload.id] || { commission: 8, discount: 5 }
    Vue.set(this.draft.rates, payload.id, { ...current, [payload.key]: payload.value })
  }

  private cancel() {
    this.$router.push({ name: 'BrowseAndGoBenefits' })
  }

  private save() {
    this.draft.name = this.draft.name.trim()
    this.draft.logo = this.draft.logo.trim().toUpperCase()
    if (!this.draft.name) {
      this.$message.error('Le nom est obligatoire')
      return
    }
    if (!this.draft.logo) this.draft.logo = this.draft.name.slice(0, 2).toUpperCase()
    if (this.wasDefault && !this.draft.isDefault) {
      this.$message.error('Désignez un autre modèle par défaut avant de retirer celui-ci.')
      this.draft.isDefault = true
      return
    }
    saveProgram(this.draft)
    this.$message.success('Modèle de Programme Avantages enregistré')
    this.$router.push({ name: 'BrowseAndGoBenefits' })
  }

  private remove() {
    this.$confirm('Supprimer ce modèle de Programme Avantages ?', 'Supprimer', {
      type: 'warning',
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler'
    }).then(() => {
      deleteProgram(this.draft.id)
      this.$message.success('Modèle de Programme Avantages supprimé')
      this.$router.push({ name: 'BrowseAndGoBenefits' })
    }).catch(() => undefined)
  }
}
